import { __assign, __spreadArrays } from "tslib";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function noopLogger() {
    return {
        trace: function () { },
        debug: function () { },
        info: function () { },
        warn: function () { },
        error: function () { },
        fatal: function () { },
        child: function () { return noopLogger(); },
    };
}
var levelNumber = {
    trace: 0,
    debug: 1,
    info: 2,
    warn: 3,
    error: 4,
    fatal: 5,
};
export function consoleLogger(level, context) {
    if (level === void 0) { level = 'warn'; }
    // tslint:disable:no-console
    // tslint:disable:no-unused-expression
    return {
        trace: function () {
            var rest = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                rest[_i] = arguments[_i];
            }
            levelNumber[level] <= 0 &&
                (context
                    ? console.log.apply(console, __spreadArrays(['TRACE', context], rest)) : console.log.apply(console, __spreadArrays(['TRACE'], rest)));
        },
        debug: function () {
            var rest = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                rest[_i] = arguments[_i];
            }
            levelNumber[level] <= 1 &&
                (context
                    ? console.log.apply(console, __spreadArrays(['DEBUG', context], rest)) : console.log.apply(console, __spreadArrays(['DEBUG'], rest)));
        },
        info: function () {
            var rest = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                rest[_i] = arguments[_i];
            }
            levelNumber[level] <= 2 &&
                (context
                    ? console.log.apply(console, __spreadArrays([' INFO', context], rest)) : console.log.apply(console, __spreadArrays([' INFO'], rest)));
        },
        warn: function () {
            var rest = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                rest[_i] = arguments[_i];
            }
            levelNumber[level] <= 3 &&
                (context
                    ? console.log.apply(console, __spreadArrays([' WARN', context], rest)) : console.log.apply(console, __spreadArrays([' WARN'], rest)));
        },
        error: function () {
            var rest = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                rest[_i] = arguments[_i];
            }
            levelNumber[level] <= 4 &&
                (context
                    ? console.log.apply(console, __spreadArrays(['ERROR', context], rest)) : console.log.apply(console, __spreadArrays(['ERROR'], rest)));
        },
        fatal: function () {
            var rest = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                rest[_i] = arguments[_i];
            }
            levelNumber[level] <= 5 &&
                (context
                    ? console.log.apply(console, __spreadArrays(['FATAL', context], rest)) : console.log.apply(console, __spreadArrays(['FATAL'], rest)));
        },
        child: function (childObj) {
            return consoleLogger(level, context ? __assign(__assign({}, context), childObj) : __assign({}, childObj));
        },
    };
}
//# sourceMappingURL=index.js.map